import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/usersActions'
import * as api from '../api/user'

function* fetchUsers(action) {
  try {
    const payload = yield call(api.getUsers, action)
    yield put({ type: constants.USERS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.USERS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* usersRefresh() {
  yield takeLatest(constants.USERS_REFRESH.ACTION, fetchUsers)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(usersRefresh)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/usersSaga.js